import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const MembersRoutes: Routes = [
  {
    path: "members",
    loadComponent: () =>
      import("./members/members.component").then((m) => m.MembersComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./members-list/members-list.component").then(
            (m) => m.MembersListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./member-form/member-form.component").then(
            (m) => m.MemberFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./member-form/member-form.component").then(
            (m) => m.MemberFormComponent,
          ),
      },
    ],
  },
];
